import { render } from "./MessageTypeManager.vue?vue&type=template&id=6cbd40e4"
import script from "./MessageTypeManager.vue?vue&type=script&lang=js"
export * from "./MessageTypeManager.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__